// .stats-section:
// 1. The stat row is justify-content-between, which has nothing to
//    distribute "between" when only one item wraps onto its own last line --
//    it just sits flush at the line's start. Detect that specific case (the
//    last item's offsetTop differs from the item before it) and center it.
// 2. Animate each stat's number counting up from 0 to its configured value
//    once scrolled into view.

(function () {
    var sections = document.querySelectorAll('.stats-section');
    if (!sections.length) return;

    sections.forEach(function (section) {
        var stats = Array.prototype.slice.call(section.querySelectorAll('.stat'));
        if (stats.length < 2) return;

        function updateSoloRow() {
            var last = stats[stats.length - 1];
            var prev = stats[stats.length - 2];
            // Remove first so the measurement reflects the natural (un-forced)
            // layout -- otherwise a previously-applied stat-solo-row (which
            // forces the item onto its own 100%-wide row) would make it
            // "measure" as solo forever after, even at widths where it
            // naturally fits alongside prev.
            last.classList.remove('stat-solo-row');
            last.classList.toggle('stat-solo-row', last.offsetTop !== prev.offsetTop);
        }

        updateSoloRow();
        window.addEventListener('resize', updateSoloRow);
    });

    // Count-up animation for .number, e.g. "1,200+" or "98%" -- only the
    // numeric portion animates, whatever prefix/suffix/comma formatting was
    // authored in the sc field is preserved.
    var DURATION = 1500;

    function parseNumberText(text) {
        var match = text.match(/[\d,]*\d(\.\d+)?/);
        if (!match) return null;
        var raw = match[0];
        return {
            target: parseFloat(raw.replace(/,/g, '')),
            prefix: text.slice(0, match.index),
            suffix: text.slice(match.index + raw.length),
            useComma: raw.indexOf(',') !== -1,
            decimals: match[1] ? match[1].length - 1 : 0,
        };
    }

    function formatNumber(value, parsed) {
        var fixed = parsed.decimals ? value.toFixed(parsed.decimals) : String(Math.round(value));
        if (parsed.useComma) {
            var parts = fixed.split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            fixed = parts.join('.');
        }
        return parsed.prefix + fixed + parsed.suffix;
    }

    function animateNumber(el) {
        var parsed = parseNumberText(el.textContent.trim());
        if (!parsed || !isFinite(parsed.target)) return;

        var start = null;
        function step(timestamp) {
            if (!start) start = timestamp;
            var progress = Math.min((timestamp - start) / DURATION, 1);
            var eased = 1 - Math.pow(1 - progress, 3); // ease-out
            el.textContent = formatNumber(parsed.target * eased, parsed);
            if (progress < 1) {
                requestAnimationFrame(step);
            } else {
                el.textContent = formatNumber(parsed.target, parsed);
            }
        }
        requestAnimationFrame(step);
    }

    var numberEls = document.querySelectorAll('.stats-section .number');
    if (!numberEls.length) return;

    if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                animateNumber(entry.target);
                observer.unobserve(entry.target);
            });
        }, { threshold: 0.4 });

        numberEls.forEach(function (el) {
            observer.observe(el);
        });
    } else {
        numberEls.forEach(animateNumber);
    }
}());
